import { Table as Mantinetable } from "@mantine/core"
import { RowCheckbox } from "../../../components/ui"
import { DisabledReason } from "@dehub/theme"
import { useTranslation } from "react-i18next"
import { SalesAction, SalesActionState, SalesOrderLike } from "../../../components/order/order-actions"
import { IOrderPlus } from "../../../models/Order"
import { ColumnDef, CellCtx } from "./columns"
import { RowActions } from "./RowActions"
import { RowActionKey } from "./types"

type Props = {
  record: IOrderPlus
  columns: ColumnDef[]
  ctx: CellCtx
  isChecked: boolean
  isSelectable: boolean
  showSelect: boolean
  onToggleSelect: (record: IOrderPlus) => void
  onAction: (key: RowActionKey, record: IOrderPlus) => void
  detailOnly?: boolean
  stateOf: (action: SalesAction, order: SalesOrderLike | null | undefined) => SalesActionState
}

export function SupplierSalesTableRow({ record, columns, ctx, isChecked, isSelectable, showSelect, onToggleSelect, onAction, stateOf, detailOnly }: Props) {
  const { t } = useTranslation("supplierSales")
  return (
    <Mantinetable.Tr>
      {showSelect && (
        <Mantinetable.Td>
          {/* Саарал чекбокс дээр дарахад шалтгаан (R4, @dehub/help); агуулгагүй бол ердийн disabled */}
          <DisabledReason helpKey="order.supplier-sales-list.reason.row-checkbox" when={!isSelectable} position="bottom-start">
            <RowCheckbox
              aria-label={t("sales.list.selectRow")}
              checked={isChecked}
              selectable={isSelectable}
              onChange={() => onToggleSelect(record)}
            />
          </DisabledReason>
        </Mantinetable.Td>
      )}
      <Mantinetable.Td>
        <RowActions record={record} stateOf={stateOf} onAction={onAction} detailOnly={detailOnly} />
      </Mantinetable.Td>
      {columns.map((c) => (
        <Mantinetable.Td key={c.id} ta={c.align === "right" ? "right" : undefined}>
          {c.render(record, ctx)}
        </Mantinetable.Td>
      ))}
    </Mantinetable.Tr>
  )
}
